interface TocItem {
  id: string;
  text: string;
}

export default function ArticleToc({ items, activeId }: { items: TocItem[]; activeId: string }) {
  if (items.length === 0) return null;

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <h2 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
        <i className="ri-list-check-2 text-primary-600" />
        本篇目录
      </h2>
      <nav className="mt-3" aria-label="文章目录">
        <ul className="space-y-1">
          {items.map((item) => (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                className={`block rounded-md px-3 py-2 text-sm leading-snug transition-colors ${
                  activeId === item.id
                    ? 'bg-primary-50 font-medium text-primary-700'
                    : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
                }`}
              >
                {item.text}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}